<script setup lang="ts">
// Overrides @basecom-gmbh/pond/components/ProductListing/ProductListingSidebar.vue
import type { Schemas } from '@shopware/api-client/api-types';

// IDS-171: add custom key and not using category in every case, add defaults
const props = withDefaults(
    defineProps<{
        filters: ListingFilter[];
        selectedFilters: Schemas['ProductListingResult']['currentFilters'];
        showResetButton?: boolean;
        fullWidth?: boolean;
        sortingOptions: Schemas['ProductListingResult']['availableSortings'];
        sorting: Schemas['ProductListingResult']['sorting'];
        productListingStoreKey?: string;
    }>(),
    {
        productListingStoreKey: 'category',
    },
);

const emit = defineEmits<{
    'sorting-changed': [key: Schemas['ProductListingResult']['sorting']];
    'filter-changed': [key: Schemas['ProductListingResult']['currentFilters']];
    'reset-filters': [];
    'reset-filter': [key: string];
    'remove-filter': [
        event: {
            code: 'properties';
            value: ValueOf<Schemas['PropertyGroupOption']['id'] | null>;
        },
    ];
}>();
</script>

<template>
    <div
        class="m-0 grid gap-4 pl-0"
        :class="{ 'px-5': !fullWidth }"
    >
        <div class="flex place-items-start justify-between gap-2">
            <ProductListingFilters
                :filters="props.filters"
                :selected-filters="props.selectedFilters"
                :show-reset-button="props.showResetButton"
                :product-listing-store-key="productListingStoreKey"
                @filter-changed="$event => $emit('filter-changed', $event)"
                @reset-filters="$emit('reset-filters')"
                @reset-filter="$event => $emit('reset-filter', $event)"
                @remove-filter="$event => $emit('remove-filter', $event)"
            />

            <div class="hidden w-48 shrink-0 place-items-start justify-end md:flex">
                <ProductListingSorting
                    :options="props.sortingOptions"
                    :selected-option="props.sorting"
                    @sorting-changed="emit('sorting-changed', $event)"
                />
            </div>
        </div>
    </div>
</template>
